import { createPopper } from '@popperjs/core';
import './dropdown-submenu.scss';

/**
 * Dropdown Submenu with dynamic positioning
 *
 * Provides hover-based nested dropdowns with intelligent positioning
 * that prevents submenus from going offscreen.
 */

document.addEventListener('DOMContentLoaded', () => {
  const submenus = document.querySelectorAll('.dropdown-submenu');

  submenus.forEach((submenu) => {
    const trigger = submenu.querySelector('a.dropdown-item');
    const menu = submenu.querySelector('.dropdown-menu');

    if (!trigger || !menu) return;

    let popperInstance = null;
    const originalParent = menu.parentElement;

    let isOverTrigger = false;
    let isOverMenu = false;

    const showSubmenu = () => {
      if (menu.classList.contains('show')) return;

      // Move menu to document.body to escape overflow-x-hidden clipping from container.
      document.body.appendChild(menu);

      menu.classList.add('show');

      popperInstance = createPopper(trigger, menu, {
        placement: 'right-start',
        strategy: 'fixed',
        modifiers: [
          {
            // Automatically flip submenu to the left when it would overflow viewport
            name: 'flip',
            options: {
              fallbackPlacements: ['left-start', 'right-end', 'left-end'],
              rootBoundary: 'viewport',
            },
          },
          {
            name: 'preventOverflow',
            options: {
              rootBoundary: 'viewport',
              padding: 8,
            },
          },
        ],
      });
    };

    const hideSubmenu = () => {
      menu.classList.remove('show');

      if (popperInstance) {
        popperInstance.destroy();
        popperInstance = null;
      }

      if (menu.parentElement !== originalParent) {
        originalParent.appendChild(menu);
      }
    };

    const updateVisibility = () => {
      if (isOverTrigger || isOverMenu) {
        showSubmenu();
      } else {
        hideSubmenu();
      }
    };

    // Trigger hover handlers
    submenu.addEventListener('mouseenter', () => {
      isOverTrigger = true;
      updateVisibility();
    });

    submenu.addEventListener('mouseleave', () => {
      isOverTrigger = false;
      updateVisibility();
    });

    // Menu hover handlers
    menu.addEventListener('mouseenter', () => {
      isOverMenu = true;
      updateVisibility();
    });

    menu.addEventListener('mouseleave', () => {
      isOverMenu = false;
      updateVisibility();
    });
  });
});
